import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Local Types
import { OwnProps, ConnectedProps, Props } from './types';

// Local Selectors
import { makeSelectMyTimesheetEntriesDayTotal } from './selectors';

export class MyTimesheetEntriesDayTotal extends React.PureComponent<Props> {
    render(): string {
        const { myTimesheetEntriesDayTotal } = this.props;
        return myTimesheetEntriesDayTotal;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    myTimesheetEntriesDayTotal: makeSelectMyTimesheetEntriesDayTotal()
});

export default connect(mapStateToProps)(MyTimesheetEntriesDayTotal);
